module.exports = __webpack_public_path__ + "static/media/MINISERIF-ITALIC.9d552f67.TTF";